<script lang="ts" setup>
import ArticleCard from "@/components/ArticleCard.vue";
import TheCommentsCard from "@/components/TheCommentsCard.vue";
import TheLayout from "@/components/TheLayout.vue";
import { Article, PaginatedCommentData } from "@/types";
import { usePage } from "@inertiajs/vue3";
import { route } from "ziggy-js";

const page = usePage();

defineProps<{
  article: Article;
  comments: PaginatedCommentData;
}>();
</script>

<template>
  <TheLayout
    :description="article.description ?? article.content"
    :heading-href="route('articles.index')"
    :show-headline="article.id !== page.props.headline?.id"
    :title="article.title"
    heading="Articles"
  >
    <ArticleCard :article="article" />

    <TheCommentsCard
      :commentable-id="article.id"
      :comments="comments"
      commentable-type="App\Models\Article"
    />
  </TheLayout>
</template>

<style scoped></style>
